/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ShipmentActivityType } from "./ShipmentActivityType";
import {
  ShipmentActivityTypeFromJSON,
  ShipmentActivityTypeFromJSONTyped,
  ShipmentActivityTypeToJSON,
  ShipmentActivityTypeToJSONTyped,
} from "./ShipmentActivityType";

/**
 *
 * @export
 * @interface ShipmentActivityEntryResponse
 */
export interface ShipmentActivityEntryResponse {
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentActivityEntryResponse
   */
  timestamp: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof ShipmentActivityEntryResponse
   */
  actorEmail?: string | null;
  /**
   *
   * @type {ShipmentActivityType}
   * @memberof ShipmentActivityEntryResponse
   */
  activityType: ShipmentActivityType;
  /**
   *
   * @type {string}
   * @memberof ShipmentActivityEntryResponse
   */
  summary: string;
}

/**
 * Check if a given object implements the ShipmentActivityEntryResponse interface.
 */
export function instanceOfShipmentActivityEntryResponse(
  value: object,
): value is ShipmentActivityEntryResponse {
  if (!("timestamp" in value) || value["timestamp"] === undefined) return false;
  if (!("activityType" in value) || value["activityType"] === undefined)
    return false;
  if (!("summary" in value) || value["summary"] === undefined) return false;
  return true;
}

export function ShipmentActivityEntryResponseFromJSON(
  json: any,
): ShipmentActivityEntryResponse {
  return ShipmentActivityEntryResponseFromJSONTyped(json, false);
}

export function ShipmentActivityEntryResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentActivityEntryResponse {
  if (json == null) {
    return json;
  }
  return {
    timestamp: json["timestamp"],
    actorEmail: json["actorEmail"] == null ? undefined : json["actorEmail"],
    activityType: ShipmentActivityTypeFromJSON(json["activityType"]),
    summary: json["summary"],
  };
}

export function ShipmentActivityEntryResponseToJSON(
  json: any,
): ShipmentActivityEntryResponse {
  return ShipmentActivityEntryResponseToJSONTyped(json, false);
}

export function ShipmentActivityEntryResponseToJSONTyped(
  value?: ShipmentActivityEntryResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    timestamp: value["timestamp"],
    actorEmail: value["actorEmail"],
    activityType: ShipmentActivityTypeToJSON(value["activityType"]),
    summary: value["summary"],
  };
}
